module.exports = __webpack_public_path__ + "static/img/icon_rg-new.3a8d918.png";